import { Button, Alert } from 'react-bootstrap';
import { FaFileInvoice, FaSpinner } from 'react-icons/fa';
import { useCreateQuotationInvoiceMutation } from '../../slices/orderApiSlice';
import { toast } from 'react-toastify';

const QuotationControls = ({ orderId, isAdmin, onSuccess }) => {
    const [createInvoice, { isLoading }] = useCreateQuotationInvoiceMutation();

    const handleCreateInvoice = async () => {
        try {
            await createInvoice(orderId).unwrap();
            toast.success('Factura creada exitosamente (pendiente de autorización)');
            if (onSuccess) onSuccess();
        } catch (err) {
            toast.error(err?.data?.message || 'Error al crear la factura');
        }
    };

    if (!isAdmin) {
        return (
            <Alert variant="warning" className="p-3">
                <div className="d-flex align-items-center gap-2">
                    <FaFileInvoice />
                    <span className="fw-bold">Cotización - Pendiente de Facturación</span>
                </div>
                <p className="mb-0 mt-2 small">
                    Tu cotización ha sido creada. Un administrador la procesará pronto.
                </p>
            </Alert>
        );
    }

    return (
        <div className="p-3 border rounded bg-light">
            <div className="mb-3">
                <div className="d-flex align-items-center gap-2 mb-2">
                    <FaFileInvoice className="text-warning" />
                    <span className="fw-bold">Cotización - Pendiente de Facturación</span>
                </div>
                <p className="mb-0 small text-muted">
                    Esta cotización necesita que se cree la factura en el sistema.
                </p>
            </div>
            <Button
                variant="primary"
                className="w-100 fw-bold"
                onClick={handleCreateInvoice}
                disabled={isLoading}
            >
                {isLoading ? (
                    <>
                        <FaSpinner className="me-2 fa-spin" />
                        Creando Factura...
                    </>
                ) : (
                    <>
                        <FaFileInvoice className="me-2" />
                        Crear Factura
                    </>
                )}
            </Button>
        </div>
    );
};

export default QuotationControls;

